import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_FLAGS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/flags',
        iconClass: 'fas fa-flag',
        name: 'Flags',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Flags',
        order: 9
      },
    ]);
  };
}
